import { useState } from "react";
import { useAuthContext } from "./useAuthContext";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:4000";

function buildQuery(params) {
    const q = Object.entries(params || {}).filter(([, v]) => v != null && v !== "").map(([k, v]) => `${k}=${encodeURIComponent(v)}`).join("&");
    return q ? `?${q}` : "";
}

export const useWorkflows = () => {
    const { user } = useAuthContext();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const auth = { Authorization: `Bearer ${user}` };
    const json = { ...auth, "Content-Type": "application/json" };

    async function req(method, path, body) {
        setLoading(true); setError(null);
        try {
            const res = await fetch(`${API_URL}${path}`, {
                method,
                headers: body ? json : auth,
                body: body ? JSON.stringify(body) : undefined
            });
            const data = await res.json();
            setLoading(false);
            if (!res.ok) { setError(data.error || "Request failed"); return null; }
            return data;
        } catch (e) {
            setError("Network error"); setLoading(false); return null;
        }
    }

    return {
        loading, error,
        listWorkflows:   (formId)                 => req("GET",    `/api/forms/${formId}/workflows`),
        createWorkflow:  (formId, data)           => req("POST",   `/api/forms/${formId}/workflows`, data),
        getWorkflow:     (id)                     => req("GET",    `/api/workflows/${id}`),
        updateWorkflow:  (id, data)               => req("PUT",    `/api/workflows/${id}`, data),
        deleteWorkflow:  (id)                     => req("DELETE", `/api/workflows/${id}`),
        testWorkflow:    (id, subId)              => req("POST",   `/api/workflows/${id}/test`, { submissionId: subId }),
        listRuns:        (id, page = 1)           => req("GET",    `/api/workflows/${id}/runs?page=${page}`),
        getRun:          (runId)                  => req("GET",    `/api/workflow-runs/${runId}`),
        listRecipes:     (category, sort)         => req("GET",    `/api/recipes${buildQuery({ category, sort })}`),
        getRecipe:       (id)                     => req("GET",    `/api/recipes/${id}`),
        installRecipe:   (formId, recipeId)       => req("POST",   `/api/forms/${formId}/workflows/recipe/${recipeId}`),
        listStepTypes:      ()                          => req("GET",    `/api/step-types`),
        costSummary:        (formId)                    => req("GET",    `/api/forms/${formId}/workflows/cost-summary`),
        listApprovals:      (runId)                     => req("GET",    `/api/workflow-runs/${runId}/approvals`),
        resolveApproval:    (approvalId, action, token, comment) =>
            req("POST", `/api/approvals/${approvalId}`, { action, token, comment }),
    };
};
